<template>
  <div>
    <div class="mb-16 md:flex" v-for="data in page.item_list" :key="data.uid">
      <div v-if="data.section">
        <h2>{{ data.section }}</h2>
      </div>
      <div v-else class="flex justify-center">
        <div class="tw_img w-64">
          <div v-if="data.to !== undefined" @click="router.push(data.to)">
            <im2 :src="data.icon" />
          </div>
          <div v-if="data.link !== undefined">
            <a :href="data.link" target="_blank">
              <im2 :src="data.icon" />
            </a>
          </div>
        </div>
      </div>
      <div class="m-4">
        <div class="tw_h2 mb-2">{{ data.title }}</div>
        <div>{{ data.desc }}</div>
        <div v-if="data.to">
          <DetailButton :to="data.to" />
        </div>
        <!-- <div v-else-if="data.link">
          <div class="mt-4 flex">
            <div class="tw_btn_detail flex items-center">
              <div>
                <a :href="data.link" target="_blank">PLAY</a>
              </div>
              <div class="ml-2">🚀</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
/* eslint-disable */
// src\views\HomeView.vue
import * as Vue from "vue";
import DetailButton from "@/components/DetailButton.vue";
import im2 from "@/components/Img2.vue";
// import { Icon } from "@iconify/vue";
import * as Helper from "@/helper";
import { useRouter } from "vue-router";
const router = useRouter();

// head - canonical 설정
import { useRoute } from "vue-router";
const route = useRoute();
import { useHead } from "@vueuse/head";
useHead({
  title: `SIDNFT | apps`,
  link: [
    {
      rel: "canonical",
      href: Vue.computed(() => {
        return Helper.canon_head + route.path;
      }),
    },
  ],
});

//
let uid_v = 1;
const app_list = [
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-04-22",
    icon: "/jcat/app_icon_512.webp",
    title: "jigsaw puzzles - brain games",
    desc: "Puzzle game with animals, scenery, and videos",
    to: "/jcat",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-01-01",
    icon: "/eb/easy_1_icon_v2.png",
    title: "122 Easy",
    desc: "Click on the square to increase the number.",
    to: "/eb",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-02-01",
    icon: "/af/app_icon.png",
    title: "Add Force 1",
    desc: "a messy physical-based defense game",
    to: "/af",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-04-24",
    icon: "/ba/ba_16_gif.webp",
    title: "Tab to Dismantle",
    desc: "Look at the direction of the arrow and tap to separate it",
    to: "/ba",
  },
  {
    uid: uid_v++,
    step: 0,
    date_mod: "2026-09-07",
    icon: "/rpg2026/rpg2026_icon_01.webp",
    title: "RPG GAME",
    desc: "I plan to produce it steadily and over the long term from the beginning.",
    to: "/rpg2026",
  },
  // TECH DEMO SECTION
  {
    uid: uid_v++,
    step: 1,
    date: "2025-12-01",
    section: "DEMO PROJECT",
  },
  // TECH DEMO APPS
  {
    uid: uid_v++,
    step: 2,
    date_mod: "2025-12-01",
    icon: "/mp/sr_app_icon.jpg",
    title: "SID-ROOM",
    desc: "The game is wildly themed with APTOS coins, NFTs, WEB3, and MMORPGs.",
    to: "https://room.sidnft.com",
  },
];

const page = Vue.ref({
  item_list: [] as any[],
});

Vue.onMounted(() => {
  app_list.sort((a, b) => {
    // 스텝 낮은게 위로
    if (a.step < b.step) return -1;
    if (a.step > b.step) return 1;

    // 최근게 위로
    if (a.date_mod > b.date_mod) return -1;
    if (a.date_mod < b.date_mod) return 1;

    return 0;
  });

  page.value.item_list = app_list;
});
</script>

<style>
/* .sm {
  font-size: 0.5em;
} */
.tw_h2 {
  @apply text-xl font-bold;
}
</style>
